import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {TranslocoRootModule} from "./transloco-root.module";
import { ServiceWorkerModule } from '@angular/service-worker';
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatDividerModule} from "@angular/material/divider";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatDialogModule} from "@angular/material/dialog";
import {MatBottomSheetModule} from "@angular/material/bottom-sheet";
import {LoadingComponent} from "./components/loading/loading.component";
import {AngularFireAuthModule} from "@angular/fire/compat/auth";
import {AngularFireModule} from "@angular/fire/compat";
import {environment} from "../environment/environment";
import {AuthentificatedComponent} from "./components/layout/authentificated/authentificated.component";
import {UnauthenticatedComponent} from "./components/layout/unauthenticated/unauthenticated.component";
import {AuthInterceptor} from "./interceptor/auth.interceptor";
import {Router} from "@angular/router";
import {Sentry} from "../sentry/sentry";


@NgModule({ declarations: [AppComponent], exports: [
        LoadingComponent
    ],
    // providers: [{
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({
    //     showDialog: true,
    //   }),
    // }, {
    //   provide: Sentry.TraceService,
    //   deps: [Router],
    // }, {
    //   provide: APP_INITIALIZER,
    //   useFactory: () => () => {
    //   },
    //   deps: [Sentry.TraceService],
    //   multi: true,
    // }],
    bootstrap: [AppComponent], imports: [AppRoutingModule,
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    BrowserAnimationsModule,
    TranslocoRootModule,
    MatSidenavModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    MatDialogModule,
    MatBottomSheetModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: false, // !isDevMode(),
        // Register the ServiceWorker as soon as the application is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: 'registerWhenStable:30000'
    }), LoadingComponent,
    AuthentificatedComponent,
    UnauthenticatedComponent], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            useFactory: () => () => {
            },
            deps: [Sentry.TraceService],
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
